<div #apMap
     id="olmap"
     [style.width]="'100%'"
     [style.height]="'100%'"
     [style.position]="'relative'">
  <ap-machine-popup></ap-machine-popup>
  <ap-sensor-point-popup></ap-sensor-point-popup>
  <ap-sensor-point-legend></ap-sensor-point-legend>
  <ap-map-zoom class="ap-map-zoom-controls"></ap-map-zoom>
  <ap-map-edit class="ap-map-edit"></ap-map-edit>
  <ap-legend-scroller></ap-legend-scroller>
  <!-- seems not to be needed anymore and causes overlay issues with our map layer tree
  <ap-map-tree-view></ap-map-tree-view>-->
  <button *ngIf="deleteButtonVisible$ | async"
          class="ap-map-clearSensorButton"
          (click)="clearSensorPoints()">
    <kendo-svg-icon [icon]="ApKendoIconService.Get('trashIcon')"></kendo-svg-icon>
  </button>
  <ap-map-context-menu></ap-map-context-menu>
  <ap-map-tooltip></ap-map-tooltip>
</div>
